import request from './requestWrapper';

// Types
import {PaginationType} from '../types/sharedTypes';
import {CarrierUserType} from "../types/carrierUserTypes";


function getParams() {
  return request({
    url: 'carrierUser/getParams',
    method: 'GET',
  });
}
function getAll(pagination: PaginationType) {
  return request({
    url: 'carrierUser/getAll',
    method: 'GET',
    params: pagination
  });
}
function create(carrier: CarrierUserType) {
  return request({
    url: 'carrierUser/create',
    method: 'POST',
    data: carrier,
  });
}
function update(carrier: CarrierUserType, carrierId: string) {
  return request({
    url: `carrierUser/update/${carrierId}`,
    method: 'PUT',
    data: carrier,
  });
}

export default {
  getParams,
  getAll,
  create,
  update,
};
